import { Component, OnInit } from "@angular/core";
import { UserService } from "./services/user.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DataLayerServiceService } from "./data-layer-service.service";
import { CommonService } from "./services/common.service";
import { AppStateService } from "./shared/app-state.service";
import { StateData } from "./shared/common";
import { filter } from "rxjs";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  token: any = "";
  currentRoute: string = '';
  constructor(
     private userSrv: UserService, 
     private commonService: CommonService, 
     private router: Router, 
     private _dataLayerService: DataLayerServiceService,
     private activatedRoute: ActivatedRoute,
     private appStateSvc: AppStateService,
     
    ) {
       this.commonService.Get('/promo/getPromoProducts').subscribe((res) => {
      if (res['meta']['status']) {
        this.appStateSvc.setState({
          discountedProduct: res['data']['product'],
        });
      }
    });
      // 

       this.appStateSvc.stateData = new StateData();      
    localStorage.setItem("optionType", "PICKUP");
    localStorage.setItem("isPickUpOrder", "true");
    // This is for sideNav Component....
    this.getUrlData();
    this.activatedRoute.queryParams.subscribe((res) => {
      this.token = res.token;
      if (this.token != undefined && this.token != null && this.token != "") {
        localStorage.setItem("token", this.token);
      }
    });
     

 this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.currentRoute = url.startsWith('/') ? url.substring(1) : url;    

        if(this.currentRoute == '') this.currentRoute = '/home'        
        this.commonService.getSeoContentForHome(this.currentRoute).subscribe((res:any) => {
          if (res) {
            const existingLink = document.querySelector("link[rel='canonical']");
            if (existingLink) {
                existingLink.remove();
            }
          if (res['canonical']) {
            const link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', res?.url);
            document.head.appendChild(link);
            }``
          this.commonService.updateMetaKeywords(res?.title, res?.keywords ,res?.description);
      }        
    });
      });

   
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._dataLayerService.logPageView(event.url); //call our dataLayer service's page view method to ping home with the url value
      }
    });
  }
  getUrlData() {
    this.commonService.getSiteData();
    let age = localStorage.getItem("ageVerify");   
    let localStoreId = localStorage.getItem("localStoreId");    
    if (!localStoreId && age == undefined && window.location.href =='https://highlifehealth.cannalogic.co/' ) {
     $("#ageVerify").modal("show"); //Age Verification
      return
    }
  }

  ngOnInit() {
    let age = localStorage.getItem("ageVerify");
    if (age == undefined || age == null || age == "") {
      $("#ageVerify").modal("show"); //Age Verification
      return;
    }
    const allReadyLoggedIn = localStorage.getItem("covaUserId");
    if (allReadyLoggedIn) {
      const user = this.getLocalStorage();
      this.afterLogin(user);
    }
  }
  

    updateCanonicalUrl(url: string) {
    // Remove existing canonical link (if any)
   

    // Add canonical tag only for home page
    if (url === '/') {
    
    }
  }
  getLocalStorage() {
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const mobileVerified = localStorage.getItem("mobileVerified");
    const documentVerify = localStorage.getItem("documentVerify");

    const user = {
      userId,
      userName,
      mobileVerified,
      documentVerify,
    };
    return user;
  }
  afterLogin(user) {
    this.userSrv.updateUserAuth(true, user);
  }
}
